export default __webpack_public_path__ + "static/media/Furatus.3eb4ea47.jpg";